import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { numberConvert } from "@website/utils/number-convert";
import { ReservePoliciesPropertiesTypes } from "@website/widget/reserve-policies/reserve-policies.types";
import { toStringTime } from "@website/widget/reserve-policies/reserve-policies.utils";
import { useRouter } from "next/router";
export const ReservePolicies = properties => {
  const $ = _c(34);
  const {
    checkinTime,
    checkoutTime,
    hotelType,
    rulesAllowed: t0,
    rulesDisAllowed: t1
  } = properties;
  let t2;
  if ($[0] !== t0) {
    t2 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const rulesAllowed = t2;
  let t3;
  if ($[2] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const rulesDisAllowed = t3;
  const router = useRouter();
  const isVilla = process.env.NEXT_PUBLIC_APP_NAME === "villa";
  let t4;
  if ($[4] !== checkinTime || $[5] !== router.locale) {
    const splitCheckinTime = checkinTime?.split("-")?.map(c => c === "infinite" ? "\u0646\u0627\u0645\u062D\u062F\u0648\u062F" : isVilla ? c : toStringTime(c));
    t4 = numberConvert((splitCheckinTime ?? []).join(" - "), {
      locale: router.locale
    });
    $[4] = checkinTime;
    $[5] = router.locale;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const checkinString = t4;
  if (!checkinTime || !checkoutTime) {
    return null;
  }
  const t5 = `قوانین ${hotelType}`;
  let t6;
  if ($[7] !== t5) {
    t6 = <h2 className="text-subtitle-1 md:text-headline-6">{t5}</h2>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="w-[24px] text-center"><MaterialIcon className="text-on-surface-medium-emphasis scale-150" name="login" /></div>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="text-caption text-on-surface-medium-emphasis">ساعت ورود</div>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== checkinString) {
    t9 = <div className="border-outline-thin flex w-max min-w-[200px] flex-col gap-2 rounded-[8px] border p-2 md:flex-row">{t7}<div className="flex flex-col gap-1 md:flex-auto">{t8}<div className="text-body-1 text-on-surface-high-emphasis">{checkinString}</div></div></div>;
    $[11] = checkinString;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="w-[24px] text-center"><MaterialIcon className="text-on-surface-medium-emphasis scale-150" name="logout" /></div>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="text-caption text-on-surface-medium-emphasis">ساعت خروج</div>;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== checkoutTime || $[16] !== router.locale) {
    t12 = numberConvert(isVilla ? checkoutTime : toStringTime(checkoutTime), {
      locale: router.locale
    });
    $[15] = checkoutTime;
    $[16] = router.locale;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12) {
    t13 = <div className="border-outline-thin flex w-[200px] flex-col gap-2 rounded-[8px] border p-2 md:flex-row">{t10}<div className="flex flex-col gap-1 md:flex-auto">{t11}<div className="text-body-1 text-on-surface-high-emphasis">{t12}</div></div></div>;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13 || $[21] !== t9) {
    t14 = <div className="flex flex-row gap-4">{t9}{t13}</div>;
    $[20] = t13;
    $[21] = t9;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== rulesAllowed) {
    t15 = rulesAllowed?.length > 0 && <div>{rulesAllowed.map(_temp)}</div>;
    $[23] = rulesAllowed;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== rulesDisAllowed) {
    t16 = rulesDisAllowed?.length > 0 && <div>{rulesDisAllowed.map(_temp2)}</div>;
    $[25] = rulesDisAllowed;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t15 || $[28] !== t16) {
    t17 = <div className="grid grid-cols-1 md:grid-cols-2">{t15}{t16}</div>;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t14 || $[31] !== t17 || $[32] !== t6) {
    t18 = <div className="flex w-full flex-col gap-4" id="hotel_policies">{t6}{t14}{t17}</div>;
    $[30] = t14;
    $[31] = t17;
    $[32] = t6;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  return t18;
};
function _temp(rule) {
  return <div className="flex items-center" key={`${rule?.title}_${rule?.id}`}><MaterialIcon className="text-success text-xl" name="check_circle" variant="outlined" /><p className="text-on-surface-high-emphasis text-body-2 mr-1">{rule?.title}</p></div>;
}
function _temp2(rule_0) {
  return <div className="flex items-center" key={`${rule_0?.title}_${rule_0?.id}`}><MaterialIcon className="text-on-surface-medium-emphasis text-xl" name="cancel" variant="outlined" /><p className="text-on-surface-high-emphasis text-body-2 mr-1">{rule_0?.title}</p></div>;
}